import React from 'react';
import ContactCellAgent from "./ContactCell/indexagent";

const ContactListAgent = ({contactList, addFavourite, onContactSelect, onSaveContact, onupdate ,onDeleteContact}) => {
  return (
    <div className="contact-main-content" >
      {contactList.map((contact, index) =>
        <ContactCellAgent key={index} contact={contact} onDeleteContact={onDeleteContact}
                     onSaveContact={onSaveContact}
                     addFavourite={addFavourite} onContactSelect={onContactSelect} onupdate={onupdate}/>
      )}
    </div>
  )
};

export default ContactListAgent;
